const MainFeature = () => import(/* webpackChunkName: "dist/js/features-main" */ './MainFeature.vue');
const SelectSubjectPage = () => import(/* webpackChunkName: "dist/js/features-main" */ './components/SelectSubjectPage.vue');
const SelectPackage = () => import(
/* webpackChunkName: "dist/js/features-main" */ '@resources/scripts/features/main/components/SelectPackage.vue');
const PackageDetails = () => import(
/* webpackChunkName: "dist/js/features-main" */ '@resources/scripts/features/main/components/PackageDetails.vue');
const SearchSubjectsPage = () => import(/* webpackChunkName: "dist/js/features-main" */ '@resources/scripts/features/main/SearchSubjectsPage.vue');
const GalleryUnavailable = () => import(/* webpackChunkName: "dist/js/features-main" */ './components/GalleryNotPublished.vue');
const GalleryFeature = () => import(/* webpackChunkName: "dist/js/features-main" */ './GalleryFeature.vue');
const ConfirmCartPage = () => import(/* webpackChunkName: "dist/js/features-cart" */ '@resources/scripts/features/cart/ConfirmCartPage.vue');
const routes = [
    {
        path: '/:studioSlug',
        component: MainFeature,
        children: [
            {
                path: 'confirmcart',
                component: ConfirmCartPage,
                meta: { title: 'Switching Galleries' },
            },
            {
                path: 'enter',
                alias: '/:studioSlug',
                meta: { title: 'Find a Gallery' },
                component: SearchSubjectsPage,
            },
            {
                path: 'unavailable',
                name: 'gallery-unavailable',
                meta: { title: 'Gallery Not Published' },
                component: GalleryUnavailable,
            },
            {
                path: ':jobId',
                component: GalleryFeature,
                children: [
                    {
                        path: 'select-subject/:passcode',
                        name: 'select-subject',
                        component: SelectSubjectPage,
                        meta: { title: 'Choose a Subject' },
                    },
                    {
                        path: 'subject/:subjectId/select-package',
                        name: 'select-package',
                        meta: { title: 'Choose a Package' },
                        component: SelectPackage,
                    },
                    {
                        path: 'subject/:subjectId/:packageId',
                        name: 'select-package-details',
                        meta: { title: 'Customize your Package' },
                        component: PackageDetails,
                    },
                ],
            },
        ],
    },
];
export default routes;
